/** @type {import('tailwindcss').Config} */
const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
  content: [
    './src/pages/**/*.tsx',
    './src/components/**/*.tsx',
    './src/templates/**/*.tsx',
    './src/assets/**/*.tsx',
  ],
  theme: {
    colors: {
      transparent: 'transparent',
      white: '#FFFFFF',
      black: '#1C1C1E',
      gray: {
        50: '#f5f5f6',
        100: '#e5e5e8',
        200: '#cdcdd4',
        300: '#aaabb6',
        400: '#848494',
        500: '#656575',
        600: '#575664',
        700: '#4b4a54',
        800: '#424149',
        900: '#3a3940',
      },
      blue: {
        50: '#EAEEFB',
        100: '#D4DCF7',
        200: '#A9B9EF',
        300: '#7F96E6',
        400: '#5472DE',
        500: '#294ED6',
        600: '#223FAF',
        700: '#1A3189',
        800: '#132362',
        900: '#0B153C',
      },
      yellow: {
        50: '#fffaeb',
        100: '#fdf1c8',
        200: '#fbe28c',
        300: '#facd4f',
        400: '#f8b622',
        500: '#f2960e',
        600: '#d67109',
        700: '#b24e0b',
        800: '#903c10',
        900: '#773210',
      },
      red: {
        50: '#fff4ed',
        100: '#ffe7d5',
        200: '#fecbaa',
        300: '#fda674',
        400: '#fb773c',
        500: '#f95216',
        600: '#de350b',
        700: '#c2270c',
        800: '#9a2112',
        900: '#7c1e12',
      },
      green: {
        50: '#E8F5E9',
        100: '#C8E6C9',
        200: '#A5D6A7',
        300: '#81C784',
        400: '#66BB6A',
        500: '#4CAF50',
        600: '#43A047',
        700: '#388E3C',
        800: '#2E7D32',
        900: '#1B5E20',
      },
    },
    container: {
      center: true,
      padding: {
        DEFAULT: '1rem',
      },
    },
    fontFamily: {
      heading: ['Poppins', ...defaultTheme.fontFamily.sans],
      body: ['Poppins', ...defaultTheme.fontFamily.sans],
      ui: ['Inter', ...defaultTheme.fontFamily.sans],
    },
    extend: {
      spacing: {
        '1/2': '50%',
        '3/4': '75%',
      },
      height: {
        'screen-3/4': '75vh',
      },
      maxHeight: theme => theme('spacing'),
      minHeight: theme => theme('spacing'),
      maxWidth: theme => theme('spacing'),
      minWidth: theme => theme('spacing'),
    },
  },
  plugins: [],
};
